// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ebe967e","boxShadow":"_c3d5037"};